const handleHeader = (defaultLang) => {
    /* Uberflip GWL OB-8079 start here */

    // if (!document.querySelector('.wglanguage-name')) {
    //     return;
    // }
    /* Uberflip GWL OB-8079 end here */
    // const langTest = document.querySelector('.wglanguage-name').innerHTML;
    let lang = defaultLang;

    setTimeout(function() {

        if (document.body.classList.contains('jpheader')) {
            lang = 'jp';
        }

        if (document.body.classList.contains('ptheader')) {
            lang = 'pt';
        }

        if (document.body.classList.contains('ruheader')) {
            lang = 'ru';
        }

        const countrySelector = document.querySelector(`.injected-header.${lang.toLowerCase()} .country-selector`);
        const countrySelectorBtn = countrySelector.querySelector('.wgcurrent');
        const countrySelectorDropdown = countrySelector.querySelector('.languages-dropdown');



        // mobile
        const mobileButtonToggle = document.querySelector(`.injected-header .header-right .menu-toggle`);
        const mobileMenuOverlay = document.querySelector(`.injected-header .menu-wrapper`);

        function closeLangMenu() {
            if (countrySelector) {
                countrySelector.classList.remove('open');
            }
            if (countrySelectorDropdown) {
                countrySelectorDropdown.classList.remove('open');
            }
        }

        function closeMobileMenu() {
            if (mobileButtonToggle) {
                mobileButtonToggle.classList.remove('open');
            }
            if (mobileMenuOverlay) {
                mobileMenuOverlay.classList.remove('open');
            }
        }


        // *******************
        // ** mobile corp nav
        // *******************

        // overlay toggle on mobile
        function mobileToggle() {
            const body = document.querySelector('body');
            if (mobileButtonToggle) {
                mobileButtonToggle.addEventListener('click', function() {
                    if (!mobileButtonToggle.classList.contains('open')) {
                        mobileButtonToggle.classList.add('open');
                        if (mobileMenuOverlay) {

                            mobileMenuOverlay.classList.add('open');
                        }
                        body.classList.add('overflow-hidden');
                        closeLangMenu(); // close language options if open
                    } else {
                        mobileButtonToggle.classList.remove('open');
                        if (mobileMenuOverlay) {
                            mobileMenuOverlay.classList.remove('open');
                        }
                        body.classList.remove('overflow-hidden');
                    }
                });
            }
        }

        // language
        function langToggle() {
            const body = document.querySelector('body');
            if (countrySelectorBtn) {
                countrySelectorBtn.addEventListener('click', function(e) {
                    e.preventDefault();
                    if (countrySelector) {
                        if (!countrySelector.classList.contains('open')) {
                            countrySelector.classList.add('open');
                            if (window.outerWidth <= 1091) {
                                body.classList.add('overflow-hidden');
                            }
                            if (countrySelectorDropdown) {
                                countrySelectorDropdown.classList.add('open');
                            }
                            closeMobileMenu(); // close mobile overlay if open

                        } else {
                            countrySelector.classList.remove('open');
                            if (window.outerWidth <= 1091) {
                                body.classList.remove('overflow-hidden');
                            }
                            if (countrySelectorDropdown) {
                                countrySelectorDropdown.classList.remove('open');
                            }
                        }
                    }
                });
            }
        }



        // *******************
        // ** desktop corp nav
        // *******************
        const submenuDropdowns = [...document.querySelectorAll('.injected-header .header .main-menu > li > ul')];
        const thirdlevelDropdowns = [...document.querySelectorAll('.injected-header .header .main-menu > li > ul ul.dropdown-menu')];
        /* Uberflip GWL OB-9117 start here */
        function closeAllSubmenu() {
            if (submenuDropdowns) {
                for (let i = 0; i < submenuDropdowns.length; i++) {
                    const parentElem = submenuDropdowns[i].parentElement;
                    submenuDropdowns[i].classList.remove('open');
                    if (parentElem) {
                        parentElem.classList.remove('open');
                    }
                }
            }
            if (thirdlevelDropdowns) {
                for (let i = 0; i < thirdlevelDropdowns.length; i++) {
                    const parentElem = thirdlevelDropdowns[i].parentElement;
                    thirdlevelDropdowns[i].classList.remove('open');
                    if (parentElem) {
                        parentElem.classList.remove('open');
                    }
                }
            }
        }
        /* Uberflip GWL OB-9117 end here */

        /* Uberflip GWL OB-9871 start here */
        function toggleSubmenu() {
            if (submenuDropdowns) {
                submenuDropdowns.forEach(function(submenuDropdown) {
                    const parentMenuItem = submenuDropdown.parentElement;

                    parentMenuItem.addEventListener('click', function(e) {
                        e.stopPropagation();
                        const clickedItem = this;
                        const clickedItemSubmenu = this.querySelector('.dropdown-menu');

                        if (clickedItem) {
                            if (!clickedItem.classList.contains('open') && e.target.parentElement === clickedItem) {
                                closeAllSubmenu();
                                clickedItem.classList.add('open');
                                if (clickedItemSubmenu) {
                                    clickedItemSubmenu.classList.add('open');
                                }
                            } else if (clickedItem.classList.contains('open') && e.target.parentElement === clickedItem) {
                                clickedItem.classList.remove('open');
                                if (clickedItemSubmenu) {
                                    clickedItemSubmenu.classList.remove('open');
                                }
                            }
                        }
                    });

                    // toggle SubSubmenu
                    let currentlyOpenItem = null;

                    const handleClickEvent = function(e) {
                        const clickedItem = this;
                        const clickedItemSubmenu = this.querySelector('.dropdown-menu');

                        if (currentlyOpenItem && currentlyOpenItem !== clickedItem) {
                            currentlyOpenItem.classList.remove('open');
                            const prevSubmenu = currentlyOpenItem.querySelector('.dropdown-menu');
                            if (prevSubmenu) {
                                prevSubmenu.classList.remove('open');
                            }
                        }

                        if (clickedItem) {
                            if (!clickedItem.classList.contains('open')) {
                                clickedItem.classList.add('open');
                                if (clickedItemSubmenu) {
                                    clickedItemSubmenu.classList.add('open');
                                }
                            } else {
                                clickedItem.classList.remove('open');
                                if (clickedItemSubmenu) {
                                    clickedItemSubmenu.classList.remove('open');
                                }
                            }
                        }

                        currentlyOpenItem = clickedItem;
                    };

                    const subSubmenuLi = [...submenuDropdown.querySelectorAll('.menu-item-has-children')];

                    if (subSubmenuLi && subSubmenuLi.length > 0) {
                        subSubmenuLi.forEach(function(subSubmenuItem) {
                            subSubmenuItem.addEventListener('click', handleClickEvent);
                        });
                    }
                });
            }
        }
        /* Uberflip GWL OB-9871 end here */

        // close submenu on when clicked anywhere but menu-items
        function closeSubmenuBodyClick() {
            const body = document.querySelector('body');
            body.addEventListener('click', function(e) {
                if (!this.classList.contains('menu-item')) {
                    closeAllSubmenu();
                }
            });
        }

        function init() {
            langToggle();
            toggleSubmenu();
            closeSubmenuBodyClick();
            mobileToggle();
        }

        init();
    }, 200);

};

module.exports = { handleHeader };


// WEBPACK FOOTER //
// ./scriptPartials/corpHeaderFooter/handleHeader.js